import { Typography } from '@remarkable/ark-web';

import { Button, ErrorPage } from 'src/components';
import { URLS } from 'src/utils/urls/urls';

export const InviterIsPaused = () => {
  return (
    <ErrorPage.Container data-cy="seat-invitation-inviter-paused">
      <ErrorPage.ErrorIcon />
      <ErrorPage.Heading>The subscription is on hold</ErrorPage.Heading>

      <ErrorPage.Content>
        <div className="flex flex-col items-center justify-center">
          <Typography variant="body-md">
            The subscription you&apos;ve been invited to is on hold. Contact the
            person that invited you to resolve the issue.
          </Typography>
          <Button as="a" to={URLS.HOME} variant="secondary" className="mt-24">
            Back to home
          </Button>
        </div>
      </ErrorPage.Content>
    </ErrorPage.Container>
  );
};
